import Footer from '../../shared/Footer';
import Airline from '../Airline';
import NextFlight from './NextFlight';
import PaySummary from './PaySummary';
import React from 'react';
import { connect } from 'react-redux';
import { isNewSeatmapDesign } from '../../../utils/seatmapDesign';

const SeatmapFooter = ({ brand, useNewDesign }) => {
  let seatmapFooterClassname = useNewDesign
    ? 'gr-flex gr-text-sm gr-w-full gr-px-4 sm:gr-px-2 sm:gr-text-base gr-justify-between gr-flex-row-reverse gr-gap-3 gr-items-center'
    : 'gr-flex gr-text-sm gr-w-full gr-p-4 sm:gr-p-0 sm:gr-text-base gr-justify-between gr-flex-row-reverse gr-gap-1 gr-items-center';
  return (
    <Footer>
      <Airline brand={brand} />
      <div className={seatmapFooterClassname}>
        <NextFlight />
        <PaySummary />
      </div>
    </Footer>
  );
};

const mapStateToProps = (state) => ({
  useNewDesign: isNewSeatmapDesign(state.session.variants),
});

export default connect(mapStateToProps)(SeatmapFooter);
